import React from "react";
import styled from "styled-components";
import { StyledText } from "../../../../components/common";
// import { NoticeBellIcon } from "../../../../components/svgs";
import NoticeBellIcon from "../../../../components/svgs/noticeBellIcon";

const NotificationCard = ({ title, createdAt, onClick, isViewed }) => {
  const formatISODate = (isoDate) => {
    const date = new Date(isoDate);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 1) {
      return "Just now";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} min ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays < 5) {
      return `${diffInDays} days ago`;
    } else {
      const day = String(date.getDate()).padStart(2, "0");
      const month = date.toLocaleString("en-US", { month: "long" });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    }
  };

  return (
    <CardWrapper onClick={onClick}>
      <IconContainer>
        <NoticeBellIcon fill="#333" />
      </IconContainer>
      <CardContainer isViewed={isViewed}>
        <CardHeader>
          <TextContainer>
            <StyledText style={{ fontSize: 14 }}>{`${title}`}</StyledText>
          </TextContainer>
          {!isViewed && <NotificationIndicator />}
        </CardHeader>
        <StyledText style={{ fontSize: 12, color: "#666666", fontWeight: 300 }}>
          {formatISODate(createdAt)}
        </StyledText>
      </CardContainer>
    </CardWrapper>
  );
};

export default NotificationCard;

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  cursor: pointer;
  background-color: #ffcc00;
  border-radius: 10px;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const IconContainer = styled.div`
  width: 25%;
  height: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardContainer = styled.div`
  width: 100%;
  background-color: ${({ isViewed }) => (isViewed ? "#fff" : "#fff4dd")};
  height: 74px;
  border-radius: 14px 0 10px 0;
  padding: 1px 15px;
`;

const TextContainer = styled.div`
  width: 90%;
  margin: 0;
  height: 40px;
`;

const NotificationIndicator = styled.div`
  background: #ffcc00;
  width: 7px;
  height: 7px;
  border-radius: 100%;
`;
